{
  "DE": "Duitsland",
  "AT": "Oostenrijk",
  "BE": "België",
  "DK": "Denemarken",
  "ES": "Spanje",
  "FR": "Frankrijk",
  "IE": "Ierland",
  "IT": "Italië",
  "LU": "Luxemburg",
  "MC": "Monaco",
  "NL": "Nederland",
  "PL": "Polen",
  "PT": "Portugal",
  "SE": "Zweden"
}
